import Joi from 'joi-browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import logo from '../../../include/images/yes-mindy-main-logo-white-color.png'
import AlertSuccess from '../../common/alertSuccess'
import {
  patientSignIn,
  patientAvailability,
  sendOtp,
  patientSignInOtp,
  mobileSignUp,
  checkOtp,
  sendWhatsappOtp,
} from '../../../store/patient'
import {
  setAppointmentObjData,
  getAppointment,
} from '../../../store/appointment'
import AlertError from '../../common/alertError'
import Form from '../../common/form/form'
import loginImg from './../../../include/images/signup/signup login-1.png'

import {
  passwordInvalid,
  passwordInvalidMax,
  passwordRequired,
  usernameRequired,
} from '../../common/misc'
import SubmitBtn from '../../common/form/submitBtn'
import { clearAllToken, setToken } from '../../services/localStorageServices'
import { loadSeo, loadTermTemplate } from '../../../store/seo'
import TermTemplatePopup from '../../common/termTemplatePopup'
import { State, City, Country } from 'country-state-city'
import Select from 'react-select'
import OtpInput from '../../doctor/common/otpInput'

class AppointmentSignUp extends Form {
  state = {
    popShow: false,
    btnClass: 'btn btn-lg btn-primary btn-block',
    loading: false,
    multi: false,
    selectedCountry: null,
    countries: [],
    isPhoneMode: false,
    data: {
      username: '',
      password: '',
      type: null,
    },
    errors: {
      username: '',
      password: '',
      type: '',
    },
    appointment: false,
    showPassword: false,
    showOtp: false,
    mobile: null,
    countDown: 59,
    reset: false,
    countDownId: 1,
    finalOtp: '',
    showSubmit: true,
    login: false,
    showUserType: false,
    availablePatientType: null,
    selectedPatientType: null,
  }

  constructor(props) {
    super(props)
    this.aRef = React.createRef()
    this.bRef = React.createRef()
    this.cRef = React.createRef()
    this.dRef = React.createRef()
  }

  togglePopup = () => {
    this.setState({ popShow: !this.state.popShow })
  }

  openPopup = (e, key) => {
    e.preventDefault()
    this.props.loadTermTemplate(key)
    this.togglePopup()
  }

  customStyles = {
    indicatorSeparator: styles => ({ display: 'none' }),
    option: (provided, state) => ({
      ...provided,
      '&:hover': {
        backgroundColor: 'rgb(95, 50, 187, 10%)',
        color: '#621ac0',
      },

      'color': state.isSelected ? '#621ac0' : 'black',
      'backgroundColor': state.isSelected
        ? 'rgb(95, 50, 187, 10%)'
        : provided.backgroundColor,
    }),
    control: (base, { isDisabled }) => ({
      ...base,
      minHeight: 60,
      borderColor: '#e0e0e0',
      borderRadius: 8,
      boxShadow: '0 !important',
      width: "110px",
    }),
      menu: (base) => ({
    ...base,
    // zIndex: 9999,
    width: "max-content", 
    minWidth: "180px",
  }),
    singleValue: (base) => ({
    ...base,
      // whiteSpace: "normal",   
      // overflow: "visible",  
      textOverflow: "unset", 
  }),
  }

  componentDidMount() {
    if (this.props.match.params.app) this.setState({ appointment: true })
    clearAllToken()
    this.props.loadSeo('patient-login')

    const countryList = Country.getAllCountries().map((c) => ({
      name: c.name,
      code: c.isoCode,
      dialCode: `+${c.phonecode}`,
    }));

    const india = countryList.find((c) => c.code === "IN");
    this.setState({
      countries: countryList,
      selectedCountry: india,
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.countDownId)
  }

  onChange = e => {
    const { name, value } = e.target
    const otp = this.state.otp
    otp[name] = value
    this.setState({ otp })
    if (name === 'a') this.bRef.current.focus()
    if (name === 'b') this.cRef.current.focus()
    if (name === 'c') this.dRef.current.focus()
  }

  onChangeType = (e) => {
    const data = { ...this.state.data }
    const errors = { ...this.state.errors }
    // console.log("onChangeType -----> ", e.target.value)
    data.type = Number(e.target.value)
    errors.type = ''
    this.setState({ data, errors })
  }

  schema = {
    password: Joi.any().when('type', {
      is: this.state.showPassword,
      then: Joi.string()
        .min(8)
        .max(25)
        .required()
        .label('Password')
        .error(errors => {
          errors.forEach(err => {
            switch (err.type) {
              case 'any.empty':
                err.message = passwordRequired
                break

              case 'string.min':
                err.message = passwordInvalid
                break

              case 'string.max':
                err.message = passwordInvalidMax
                break
            }
          })
          return errors
        }),
    }),
    username: Joi.string()
      .required()
      .label('Username')
      .error(() => {
        return { message: usernameRequired }
      }),
    type: Joi.any(),
  }

  doSubmit = () => {
    const { showPassword, showOtp, mobile, showSubmit } = this.state
    if (showPassword) {
      if (!this.state.loading) {
        this.setState({
          btnClass: 'btn btn-lg btn-primary btn-block disabled',
          loading: true,
        })
        const {
          data: { username, password, type },
        } = this.state
        const payload = {
          username,
          password,
        }
        if (this.state.multi) {
          payload['type'] = type
        }
        this.props.patientSignIn(payload, this.callback)
      }
    } else if (showOtp) {
      const { finalOtp } = this.state
      if (
        this.state.login &&
        this.state.availablePatientType ===
        this.state.selectedPatientType  
      ) {
        const data = {
          mobile: this.state.email ? this.state.email : this.state.mobile,
          otp: finalOtp,
        }

        if (this.state.multi) {
          data['type'] = this.state.data.type
        }
      // console.log("showOtp type : ", data)
        this.props.patientSignInOtp(data, this.callback)
      } else {
        const data = {
          mobile: this.state.mobile,
          otp: finalOtp,
        }
        // console.log("checkOtp type : ", data)
        this.props.checkOtp(data, this.callBaclOtpCheck)
      }
    } else {
      if (!this.state.loader) {
        if (
          !isNaN(parseInt(this.state.data.username)) &&
          (this.state.data.username.length < 8 || this.state.data.username.length > 15)
        ) {
          this.setState({
            errors: {
              username: 'Invalid mobile number. Do not enter country code',
            },
          })
          return
        }
        this.setState({
          loader: true,
          btnClass: 'btn btn-lg btn-primary btn-block disabled',
        })
        const params = {
          username: this.state.data.username,
          mobileCode: this.state.selectedCountry.dialCode,
        }
        this.props.mobileAvailability(params, this.checkPatientCallback)
      }
    }
  }

  callBaclOtpCheck = res => {
    if (res.status === 200) {
      if(this.state.availablePatientType ===
         this.state.selectedPatientType){
          this.setState({
            showUserType: true,
          }) 
        } else {
          this.handleRegister(this.state.selectedPatientType);
        }
      
    } else {
      this.setState({ disabledbutton: true })
      return toast(<AlertError message={res.data.error} />)
    }
  }

  checkPatientCallback = res => {
    if (!res) return
    this.setState({
      loader: false,
      btnClass: 'btn btn-lg btn-primary btn-block',
    })

    if (res.status === 200) {
      if (!res.data.data.length) {
        return toast(<AlertError message={res.data.error} />)
      } else {
        if (this.state.showSubmit) {
          this.setState({
            showPassword: false,
            showOtp: false,
            login: true,
            showSubmit: false,
          })
          if(res.data.data.length === 1)
            this.setState({
              availablePatientType: res.data.data[0].type,
              selectedPatientType: res.data.data[0].type,
             })
        } else if (
          this.state.availablePatientType !=
          this.state.selectedPatientType
        ) {
          // console.log("reached to register flow")
          const params = {
            mobile: this.state.data.username,
            mobileCode: this.state.selectedCountry.dialCode,
            type: 'resetPassword',
          }
          this.props.sendOtp(params, this.otpCheckCallBack)
        }
        else {
          if (res.data.data.length === 2) {
            this.setState({ type: 3 })
          } else {
            this.setState({ type: res.data.data[0].type })
          }
          const params = {
            mobile: res.data.data[0].mobile,
            email: res.data.data[0].email,
            mobileCode: res.data.data[0].mobileCode,
            type: 'resetPassword',
          }
          this.setState({
            mobile: res.data.data[0].mobile,
            email: res.data.data[0].email,
          })
          this.props.sendOtp(params, this.otpCallBack)
        }
      }
    } else if (
      res.status === 400 &&
      res.data.error === 'Sorry. this account does not exist.'
    ) {
      const params = {
        mobile: this.state.data.username,
        mobileCode: this.state.selectedCountry.dialCode,
        type: 'resetPassword',
      }
      this.props.sendOtp(params, this.otpCheckCallBack)
    } else {
      toast(<AlertError message={res.data.error} />)
    }
  }

  otpCheckCallBack = res => {
    if (res.status === 200) {
      toast(<AlertSuccess message={res.data.otp} />)
      this.setState({
        showPassword: false,
        showOtp: true,
        mobile: res.data.mobile,
        showSubmit: false,
      })
      const countDown = setInterval(() => {
        if (this.state.countDown === 1 || this.state.reset)
          clearInterval(countDown)
        this.setState({ countDown: this.state.countDown - 1 })
      }, 1000)
      this.setState({ countDownId: countDown })
    } else {
      toast(<AlertError message={res.data.error} />)
    }
  }

  otpCallBack = res => {
    if (res.status === 200) {
      toast(<AlertSuccess message={res.data.otp} />)
      this.setState({
        showPassword: false,
        showOtp: true,
      })
      const countDown = setInterval(() => {
        if (this.state.countDown === 1 || this.state.reset)
          clearInterval(countDown)
        this.setState({ countDown: this.state.countDown - 1 })
      }, 1000)
      this.setState({ countDownId: countDown })
    } else {
      toast(<AlertError message={res.data.error} />)
    }
  }

  reSend = e => {
    clearInterval(this.state.countDownId)
    const param = {
      mobile: this.state.mobile,
      email: this.state.email,
      mobileCode: this.state.selectedCountry.dialCode,
      type: 'resetPassword',
    }
    this.props.sendOtp(param, this.resendCallback)
    e.preventDefault()
  }

  resendCallback = res => {
    if (res.status === 200) {
      this.setState({ countDown: 59, reset: true }, () => {
        const countDown = setInterval(() => {
          if (this.state.countDown === 1) clearInterval(countDown)
          this.setState({ countDown: this.state.countDown - 1 })
        }, 1000)

        this.setState({ countDownId: countDown })
      })

      toast(<AlertSuccess message={res.data.otp} />)
    } else {
      toast(<AlertError message={res.data.error} />)
    }
  }

  callback = res => {
    this.setState({
      btnClass: 'btn btn-lg btn-primary btn-block',
      loading: false,
    })
    if (res.status === 403 || res.status === 400)
      return toast(<AlertError message={res.data.error} />)
    if (res.status === 409) {
      this.schema.type = Joi.any()
      .required()
      .label("Type")
      .error(() => {
        return { message: 'Please select Self or Guardian' };
      })

      this.setState({
        multi: true,
        data: {
          username: this.state.data.username,
          password: this.state.data.password,
          // type: null,
        },
        errors: { username: '', password: '', type: '' },
      })
      return
    }
    if (res.status === 200) {
      const { xAuthToken, xRefreshToken } = res.data
      setToken(xRefreshToken, xAuthToken)
      localStorage.setItem('patient', JSON.stringify(res.data.data))
      if (sessionStorage.getItem('initialurl')) {
        const url = sessionStorage.getItem('initialurl')
        sessionStorage.removeItem('initialurl')
        this.props.history.push(JSON.parse(url))
      } else if (this.state.appointment) {
        if (this.props.match.params.profile) {
          // console.log("1nd------------------>")
          return this.props.history.push({
            pathname: '/dr/' + this.props.match.params.profile + '/appointment',
            appointId: 'yes',
          })
        }
        this.props.history.push('/patient/doctors')
      } else if (this.props.match.params.profile) {
        // console.log("2nd------------------>")
        this.props.history.push({
          pathname: '/dr/' + this.props.match.params.profile + '/appointment',
          // appointId: 'yes',
        })
      } else {
        this.props.history.push('/patient/dashboard')
      }
    }
  }

  renderOtpInput = () => {
    return (
      <div className='enter-otp-box'>
        <p>OTP Sent to Phone Number/ Email</p>
        <div className='otp-box'>
          <OtpInput
            length={4}
            onChangeOtp={(otp) => {
              this.setState({ finalOtp: otp })
            }}
          />
        </div>
        <div className='time-count'>
          Code expires in:{' '}
          <span>
            00:
            {parseInt(
              this.state.countDown > 9
                ? this.state.countDown
                : '0' + this.state.countDown
            )}
          </span>
        </div>
      </div>
    )
  }

  handlePassword = () => {
    if (this.state.showPassword) {
      this.setState(
        {
          showPassword: false,
        },
        () => {
          this.doSubmit()
        }
      )
    } else {
      this.setState({
        showPassword: true,
        showOtp: false,
      })
    }
  }

  handleRegister = (type) => {
    const isMobile = !isNaN(parseInt(this.state.mobile));
    const data = {
      type: type,
      [isMobile ? 'mobile' : 'email']: this.state.mobile,
      ...(isMobile && {
        mobileCode: this.state.selectedCountry.dialCode,
        country: this.state.selectedCountry.name  
      }),
    }
    this.setState({ loading: true })
    this.props.mobileSignUp(
      data,
      this.callBackSignUp,
      'mobileAppointmentSignUp'
    )
  }

  callBackSignUp = res => {
    this.setState({ loading: false })
    if (res.status === 200) {
      const { xAuthToken, xRefreshToken } = res.data
      setToken(xRefreshToken, xAuthToken)
      localStorage.setItem('patient', JSON.stringify(res.data.data))

      if (this.props.match.params.profile) {
        return this.props.history.push({
          pathname: '/dr/' + this.props.match.params.profile + '/appointment',
          appointId: 'yes',
        })
      }
    } else {
      return toast(<AlertError message={res.data.error} />)
    }
  }
  handleUsernameChange = (e) => {
    const { value } = e.target;
    const isPhone = /^\d+$/.test(value);

    const data = { ...this.state.data };
    data.username = value;

    const errors = { ...this.state.errors };
    errors.username = "";

    this.setState({
      data,
      errors,
      isPhoneMode: isPhone,
    });
  };
  getWhatsappOtp = e => {
    const param = {
      mobile: this.state.mobile,
      mobileCode: this.state.selectedCountry.dialcode,
      email: this.state.email,
    }
    this.props.sendWhatsappOtp(param, this.whatsappCallback)
    e.preventDefault()
  };

  whatsappCallback = res => {
    // console.log("res----------> ", res)
    if (res.status === 200) {
      toast(<AlertSuccess message={res.data.message} />)
    } else {
      toast(<AlertError message={res.data.message} />)
    }
  }

  render() {
    const { showPassword, showOtp, showSubmit, login, showUserType } =
      this.state

    return (
      <div className='member-container'>
        <div className='top-logo'>
          <a href='/'>
            {' '}
            <img src={logo} alt='' />
          </a>
        </div>
        <div className='member-bg hero-background1'></div>
        <div className='member-box d-flex login-form'>
          <div className='member-left'>
            <div className='ml-box'>
              <h1>YesMindy.</h1>
              <p className='mb-0'>Please enter your password to continue</p>
            </div>
          </div>

          <div className='member-right'>
            <div className='member-right-content d-md-flex align-items-center'>
              <div className='mr-box'>
                <div className='mr-head'>
                  <h2>{showUserType ? 'Choose User Type' : 'Login'}</h2>
                  {/* {!this.state.appointment && (
                    <p className="login-text">
                      New user? <Link to="sign-up">Sign Up</Link>
                    </p>
                  )} */}
                </div>
                {showUserType ? (
                  <>
                    <div className='form-group'>
                      <a
                        className='btn btn-lg btn-secondary btn-block'
                        onClick={e => {
                          this.handleRegister(1)
                        }}>
                        <span>For Myself</span>
                      </a>
                    </div>
                    <div className='form-group'>
                      <a
                        className='btn btn-lg btn-secondary btn-block'
                        onClick={e => {
                          this.handleRegister(2)
                        }}>
                        <span>
                          I am Guardian/Caretaker
                          <small className='d-block'>
                            (Below 18yrs age or dependent client)
                          </small>
                        </span>
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <form action='' onSubmit={this.handleSubmit}>
                      <div className='form-box'>
                        {/* {this.renderInput('username', 'Mobile / Email')} */}
                      <div className="form-group">
                        {login && this.state.selectedPatientType && (
                          <div
                            className="custom-radio-outer radio-style">
                            <div className="custom-control custom-radio">
                              <input
                                type="radio"
                                className="custom-control-input"
                                id="consultSelf"
                                name="consultFor"
                                value={1}
                                checked={this.state.selectedPatientType === 1}
                                onChange={() =>
                                  this.setState({ selectedPatientType: 1 })
                                }
                              />
                              <label
                                className="custom-control-label radio-style-label"
                                htmlFor="consultSelf"
                              >
                                Consult for Yourself
                              </label>
                            </div>

                            <div className="custom-control custom-radio">
                              <input
                                type="radio"
                                className="custom-control-input"
                                id="consultGuardian"
                                name="consultFor"
                                value={2}
                                checked={this.state.selectedPatientType === 2}
                                onChange={() =>
                                  this.setState({ selectedPatientType: 2 })
                                }
                              />
                              <label
                                className="custom-control-label radio-style-label"
                                htmlFor="consultGuardian"
                              >
                                Consult for Child/ Parent/ Partner
                              </label>
                            </div>
                          </div>
                        )}
                        <label className='login-text'>Mobile / Email</label>
                        <div style={{ display: "flex", gap: "8px" }}>
                          {this.state.isPhoneMode && (
                            <Select
                              styles={this.customStyles}
                              placeholder="Select Country Code"
                              value={
                                this.state.selectedCountry
                                  ? {
                                      label: this.state.selectedCountry.name,
                                      value: this.state.selectedCountry.code,
                                      code: this.state.selectedCountry.code,
                                      dialCode: this.state.selectedCountry.dialCode,
                                    }
                                  : null
                              }
                              onChange={(selected) => {
                                const chosen = this.state.countries.find(
                                  (c) => c.code === selected.value
                                );
                                this.setState({ selectedCountry: chosen });
                              }}
                              options={this.state.countries.map((c) => ({
                                label: c.name,
                                value: c.code,
                                code: c.code,
                                dialCode: c.dialCode,
                              }))}
                              getOptionLabel={(option) => `${option.dialCode} - ${option.label}`} 
                              formatOptionLabel={(option, { context }) => {
                                if (context === "value") {
                                  return `${option.code} ${option.dialCode}`;
                                }
                                return `${option.dialCode} - ${option.label}`;
                              }}
                            />
                          )}
    
                          <input
                            type='text'
                            inputMode={this.state.isPhoneMode ? "tel" : "email"} 
                            name="username"                     
                            value={this.state.data.username} 
                            onChange={this.handleUsernameChange} 
                            className= {this.state.errors.username ? "form-control error" :"form-control"}
                            placeholder="Enter Mobile or Email"  
                          />
                        </div>
                        {this.state.errors.username && (
                          <div className="text-danger" style={{ fontSize: "12px" }}>
                            {this.state.errors.username}
                          </div>
                        )} 
                      </div>
                        <div className='mr-head'>
                          <p
                            className='login-text'
                            style={{ marginTop: 0, marginBottom: 10, fontSize: '13px'}}>
                            International Clients Use WhatsApp Number/ Email
                          </p>
                        </div>
                        {showPassword &&
                          this.renderPasswordInput('password', 'Password')}
                        {showOtp && this.renderOtpInput()}

                        {/* {this.state.multi &&
                          this.renderSelect(
                            'type',
                            'Account Type',
                            [
                              { id: 1, name: 'Self' },
                              { id: 2, name: 'Caretaker/Guardian' },
                            ],
                            1
                          )} */}

                         {this.state.multi && (
                          <div className="form-group mt-3">
                            <div className="custom-radio-outer radio-container">
                              <label className="mb-2 d-block radio-style-label">Select Type <span className="text-danger">*</span></label>
                              <div className="custom-control custom-radio">
                                <input
                                  type="radio"
                                  className="custom-control-input"
                                  id="typeSelf"
                                  name="type"
                                  value={1}
                                  checked={this.state.data.type === 1}
                                  onChange={e => this.onChangeType(e)}
                                />
                                <label className="custom-control-label radio-style-label" htmlFor="typeSelf">
                                  Self
                                </label>
                              </div>

                              <div className="custom-control custom-radio mt-2">
                                <input
                                  type="radio"
                                  className="custom-control-input"
                                  id="typeGuardian"
                                  name="type"
                                  value={2}
                                  checked={this.state.data.type === 2}
                                  onChange={e => this.onChangeType(e)}
                                />
                                <label className="custom-control-label radio-style-label" htmlFor="typeGuardian">
                                  Guardian / Caretaker
                                </label>
                              </div>
                            </div>
                            
                            {this.state.errors.type && (
                              <small className="text-danger d-block">{this.state.errors.type}</small>
                            )}
                          </div>
                        )}  

                        {showOtp && this.state.isPhoneMode && this.state.selectedCountry?.dialCode === '+91' && (
                          <div className='whatsapp-box'>
                            <p className='whatsapp-content'>
                              <span className='whatsapp-text' onClick={this.getWhatsappOtp}>
                                Get code on WhatsApp
                                <img
                                  src='https://cdn-icons-png.flaticon.com/512/733/733585.png'
                                  alt='WhatsApp'
                                  className='whatsapp-logo'
                                />
                              </span>
                            </p>
                          </div>
                        )}

                        {showOtp && (
                          <div className='resend-box pb-2'>
                            {this.state.countDown === 0 && (
                              <p>
                                Didn't get the code?{' '}
                                <a href='#' onClick={this.reSend}>
                                  Resend
                                </a>
                              </p>
                            )}
                          </div>
                        )}

                        {showSubmit ? (
                          <>
                            <div
                              className='form-group'
                              style={{ marginBottom: 0 }}>
                              <SubmitBtn
                                label={'Submit'}
                                loading={this.state.loading}
                                btnClass={this.state.btnClass}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className='form-group'
                              style={{ marginBottom: 0 }}>
                              <SubmitBtn
                                label={
                                  showPassword || showOtp
                                    ? 'Login'
                                    : 'Login With Otp'
                                }
                                loading={this.state.loading}
                                btnClass={this.state.btnClass}
                              />
                            </div>

                            {login &&
                              this.state.availablePatientType ===
                                this.state.selectedPatientType && (
                                <>
                                  <div className='resend-box'>
                                    <p>or</p>
                                  </div>

                                  <div className='form-group'>
                                    <button
                                      type='button'
                                      onClick={this.handlePassword}
                                      className={this.state.btnClass}>
                                      Login With{' '}
                                      {showPassword ? 'OTP' : 'Password'}
                                    </button>
                                  </div>
                                </>
                            )}
                          </>
                        )}

                        {/* {!this.state.appointment && ( */}
                        {login &&
                          this.state.availablePatientType ===
                          this.state.selectedPatientType && (
                            <p className='forgot-password text-center'>
                              <Link
                                to={`/patient/appointment/forget-password/${this.props.match?.params?.profile}`}
                                onClick={() => {
                                  this.props.setAppointmentObjData({
                                    mobile: this.state.data.username,
                                  })
                                }}>
                                Forgot/Set Password
                              </Link>
                            </p>
                          )  
                        }
                        {/* <div class="seprator">or</div>
                        <div class="login-as-text-box text-center">
                          <h5>
                            <Link to="/doctor/sign-in">
                              Login as a Health Professional
                            </Link>
                          </h5>
                        </div> */}
                      </div>
                    </form>
                  </>
                )}
              </div>

              <div class='mr-bottom'>
                <p>
                  By clicking login, I agree to{' '}
                  <a href='' onClick={e => this.openPopup(e, 'PatientTerms')}>
                    terms of service
                  </a>{' '}
                  and{' '}
                  <a
                    onClick={e => this.openPopup(e, 'user-privacy-policy')}
                    href=''>
                    privacy policy.
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <TermTemplatePopup
          show={this.state.popShow}
          toggle={this.togglePopup}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  getAppointment: getAppointment(state),
})

const mapDispatchToProps = dispatch => ({
  patientSignIn: (param, callback) => dispatch(patientSignIn(param, callback)),
  patientSignInOtp: (param, callback) =>
    dispatch(patientSignInOtp(param, callback)),
  loadSeo: page_key => dispatch(loadSeo(page_key)),
  loadTermTemplate: key => dispatch(loadTermTemplate(key)),
  mobileAvailability: (param, callback) =>
    dispatch(patientAvailability(param, callback)),
  sendOtp: (param, callback) => dispatch(sendOtp(param, callback)),
  mobileSignUp: (data, callback, name) =>
    dispatch(mobileSignUp(data, callback, name)),
  checkOtp: (param, callback) => dispatch(checkOtp(param, callback)),
  sendWhatsappOtp: (param, callback) => dispatch(sendWhatsappOtp(param, callback)),
  setAppointmentObjData: data => dispatch(setAppointmentObjData(data)),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentSignUp)
)
